module.exports = __webpack_public_path__ + "img/arrival_2.1fc3ca4b.jpg";